import { useStorage } from './use-storage'

// to get over cache issues, we use a local storage version
// to get the avatar on that session...
// didn't have a better idea...
export const useLocalAvatarVersion = () => {
  return useStorage(
    'localStorage',
    (z) =>
      z.object({
        version: z.string(),
        expiresAt: z.number(),
      }),
    `local-avatar-version`,
    { initialValue: { version: '', expiresAt: 0 } }
  )
}
